import {Button} from 'antd';
import React from 'react';
import {useNavigate} from 'react-router-dom';

import {allRoutes} from '../../../constants/Routes';

const StartPCFButton: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Button
      className="lp-hero-cta"
      onClick={() => {
        navigate(allRoutes.PCF.studies);
      }}
    >
      Start PCF Study
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path
          d="M5 12H19M19 12L12 5M19 12L12 19"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Button>
  );
};

export default StartPCFButton;
